const __request = require(`./__request/__request_contentType_json`);

// 采购订单数量查询
const recordCount = (data) => {
let pParameter = {
    method: 'post',
    // urlSuffix: '/flight/domestic/buyer/manage/order/recordCount',
    urlSuffix:'/buyer/dom/manage/count',
    data:data
  }

  return __request(pParameter)
}
export default recordCount
